import axiosInstance from './axiosInstance';

export const auditLogsApi = {
  /**
   * Get paginated audit logs with filters
   */
  getAuditLogs: async ({
    page = 0,
    size = 20,
    action,
    entityType,
    userEmail,
    module,
    startDate,
    endDate,
    search,
    sortBy = 'timestamp',
    sortDir = 'desc'
  } = {}) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('size', size);
      params.append('sortBy', sortBy);
      params.append('sortDir', sortDir);

      if (action) params.append('action', action);
      if (entityType) params.append('entityType', entityType);
      if (userEmail) params.append('userEmail', userEmail);
      if (module) params.append('module', module);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (search) params.append('search', search);

      const response = await axiosInstance.get(`/Corrohealth/api/admin/audit-logs?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get dashboard statistics
   */
  getDashboardStats: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/admin/audit-logs/dashboard');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get filter options (entity types, modules, users, actions)
   */
  getFilterOptions: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/admin/audit-logs/filters');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get single audit log by ID
   */
  getAuditLogById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/api/admin/audit-logs/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get audit history for a specific entity
   */
  getEntityHistory: async (entityType, entityId) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/api/admin/audit-logs/entity/${entityType}/${entityId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get audit history for a specific user
   */
  getUserHistory: async (email) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/api/admin/audit-logs/user/${encodeURIComponent(email)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get recent audit logs
   */
  getRecentLogs: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/admin/audit-logs/recent');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
